<div fxLayout="row" fxLayoutAlign="space-between center">
  <strong class="detail-title">EDI File: {{ data.mbl }}</strong>
  <div fxLayout="row" fxLayoutAlign="end center">
    <mat-icon class="material-icons-outlined clickable" [mat-dialog-close]="false">close</mat-icon>
  </div>
</div>
<pre>
  {{ xmlEdiFile }}
</pre>
